const createRedirectedEvent = originalEvent => {
	const newEvent = new Event(originalEvent.type, {
		bubbles: true,
		cancelable: true,
	});
	
	// Copy important properties from original event
	newEvent.clientX = originalEvent.clientX;
	newEvent.clientY = originalEvent.clientY;
	newEvent.screenX = originalEvent.screenX;
	newEvent.screenY = originalEvent.screenY;
	newEvent.ctrlKey = originalEvent.ctrlKey;
	newEvent.shiftKey = originalEvent.shiftKey;
	newEvent.altKey = originalEvent.altKey;
	newEvent.metaKey = originalEvent.metaKey;
	newEvent.button = originalEvent.button;
	newEvent.buttons = originalEvent.buttons;
	
	// For wheel events
	if (originalEvent.deltaX !== undefined) {
		newEvent.deltaX = originalEvent.deltaX;
		newEvent.deltaY = originalEvent.deltaY;
		newEvent.deltaZ = originalEvent.deltaZ;
		newEvent.deltaMode = originalEvent.deltaMode;
	}
	
	// For touch events
	if (originalEvent.touches) {
		newEvent.touches = originalEvent.touches;
		newEvent.targetTouches = originalEvent.targetTouches;
		newEvent.changedTouches = originalEvent.changedTouches;
		newEvent.touchType = originalEvent.touchType;
	}
	
	// For pointer events
	if (originalEvent.pointerId !== undefined) {
		newEvent.pointerId = originalEvent.pointerId;
		newEvent.width = originalEvent.width;
		newEvent.height = originalEvent.height;
		newEvent.pressure = originalEvent.pressure;
		newEvent.tangentialPressure = originalEvent.tangentialPressure;
		newEvent.tiltX = originalEvent.tiltX;
		newEvent.tiltY = originalEvent.tiltY;
		newEvent.twist = originalEvent.twist;
		newEvent.pointerType = originalEvent.pointerType;
		newEvent.isPrimary = originalEvent.isPrimary;
	}
	return newEvent;
};


const redirectEventFactory = selector => event => {
	let underlyingElement;
	if (typeof event.clientX === 'number' && typeof event.clientY === 'number') {
		const currentTarget = event.currentTarget;
		if (currentTarget && currentTarget.style) {
			const previousPointerEvents = currentTarget.style.pointerEvents;
			currentTarget.style.pointerEvents = 'none';
			underlyingElement = document.elementFromPoint(event.clientX, event.clientY);
			currentTarget.style.pointerEvents = previousPointerEvents;
		}
		// Pointer cursor and click on OSM attribution link
		if (underlyingElement && underlyingElement.closest) {
			const osmLink = underlyingElement.closest('a[href^="https://www.openstreetmap.org/"]');
			if (osmLink) {
				document.body.style.cursor = 'pointer';
				if (event.type === 'pointerdown') {
					osmLink.click();
					return;
				}
			} else if (document.body.style.cursor === 'pointer') {
				document.body.style.cursor = '';
			}
		} else if (document.body.style.cursor === 'pointer') {
			document.body.style.cursor = '';
		}
	}
	
	const element = document.querySelector(selector);
	if (element) {
		element.dispatchEvent(createRedirectedEvent(event));
	}
};

export { redirectEventFactory };
